import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import Typography from '@mui/material/Typography'
import { Column, Row } from 'src/components/Layout/Styled'
import { isMediaWidthMoreThan } from 'src/utils/lib'
import { handleBatchPeriod } from '../Step1/events'
import { StepTitle } from '..'
import { StyledDivider } from './Styled'
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import Detail from './Detail'
import InformationItem from './InformationItem'

const Step2 = () => {
  const { data, batch } = useSelector(
    (state) => ({
      data: state.eLearningEnroll.data,
      batch: state.eLearningEnroll.body.batch,
    }),
    shallowEqual
  )
  const isNotSm = isMediaWidthMoreThan('md')

  return (
    <Column gap={2}>
      <Column gap={2}>
        <StepTitle label="กรุณากรอกข้อมูลสำหรับการสมัครเข้าอบรมให้ครบถ้วน" />
        {!isNotSm && <StyledDivider />}
      </Column>

      <Column sx={{ background: '#FAFAFA', mb: 2, p: 3, rowGap: 2 }}>
        <Row>
          <InsertInvitationIcon
            sx={{ mr: 1, fontSzie: 24, color: '#00008F' }}
          />
          <Typography variant="h6" color="primary.main">
            {`รายละเอียดเข้าอบรม`}
          </Typography>
        </Row>
        <Column sx={{ background: '#FFFFFF', p: 2, rowGap: '12px' }}>
          <Detail
            label={'ชื่อหลักสูตร'}
            value={data.nameForLearner || data.name || '-'}
          />
          <Detail
            label={'วันที่เริ่มอบรม'}
            value={handleBatchPeriod(batch, 'periodStart')}
          />
          <Detail
            label={'วันที่จบอบรม'}
            value={handleBatchPeriod(batch, 'periodEnd')}
          />
        </Column>
      </Column>
      <StyledDivider />

      <Column sx={{ background: '#FAFAFA', p: 3, rowGap: 2 }}>
        <Row>
          <GroupsOutlinedIcon sx={{ mr: 1, fontSzie: 24, color: '#00008F' }} />
          <Typography variant="h6" color="primary.main">
            {`อัปเดทข้อมูล`}
          </Typography>
        </Row>
        <InformationItem index={0} />
      </Column>
    </Column>
  )
}

export default Step2

export const LabelAndData = ({ label, value }) => {
  return (
    <Row gap={3}>
      <Typography variant="body1b" color="text.secondary" width={220}>
        {label}
      </Typography>
      <Typography>{value}</Typography>
    </Row>
  )
}
